<label *ngIf="label">{{ label }}</label>
<nz-range-picker
  [(ngModel)]="internalValue"
  [nzDisabled]="disabled"
  [nzSeparator]="dashSeparator"
  (blur)="syncExternalTouched()"
  (ngModelChange)="onModelChange($event)"></nz-range-picker>

<ng-template #dashSeparator> - </ng-template>
